import React, { Component } from "react"
import { connect } from "react-redux"

import { addEntertainment } from "../../redux/actions/basket-actions"
import { nextPage } from "../../redux/actions/journey-actions"
import Button from "../../components/shared/button/text-button"
import "./select-extras-page.scss"
import Entertainment from "../../components/choose-entertainment/entertainment"

class SelectEntertainmentPage extends Component {
  gotoNextPage() {
    this.props.gotoNextPage()
  }

  render() {
    const { entertainmentData, excludeVAT, entertainment, planID } = this.props
    return (
      <>
        <div className="entertainment-list">
          <Entertainment
            text={entertainmentData.mainText}
            images={entertainmentData.images}
            cost={entertainmentData.monthly}
            excludeVAT={excludeVAT}
            selectedEntertainment={entertainment}
            onAddEntertainment={entertainmentCost => {
              this.props.addEntertainment(entertainmentCost, planID)
            }}
            planID={planID}
            buttonText={"Add entertainment"}
          />
        </div>
        <div className="continue-button">
          <Button text="Continue" onClick={() => this.gotoNextPage()} />
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  entertainmentData:
    state.basket.phoneID === "SIMO"
      ? state.benefits.byID["SIMO_ENTERTAINMENT_PROVIDERS"]
      : state.benefits.byID["ENTERTAINMENT_PROVIDERS"],
  selectedExtras: state.basket.extras,
  entertainment: state.basket.entertainment,
  excludeVAT: state.plans.options.excludeVAT,
  planID: state.basket.planID
})

const mapDispatchToProps = dispatch => ({
  gotoNextPage: () => dispatch(nextPage()),
  addEntertainment: (entertainmentCost, planID) =>
    dispatch(addEntertainment(entertainmentCost, planID))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectEntertainmentPage)
